import { combineEpics } from 'redux-observable';
import { onSave, onClose, onComplete, onError } from './create.tsx';

export default combineEpics(onSave, onClose, onComplete, onError);
